import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import requiredSetupMappings from '../../../../components/required-setup-mappings';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import SearchForm from '../../../../components/search-form';
import PipelineDateDropdown, { convertPipeline } from '../../components/pipeline-date-dropdown';
import { clearCache } from '../../../../components/dynamic-cell/actions';
import PipelineStats from '../../components/pipeline-stats';
import PipelineGraphs from '../../components/pipeline-graphs';
import NumberDisplay from '../../../../components/number-display';
import {
  getStatsLoading, getStatsLoaded, getOpportunities,
  getConversionGraphLoading, getConversionGraphLoaded,
  getConversionGraphOpportunities,
  getStatsErrors,
} from '../../PipelineReducer';
import {
  fetchStats, resetStats, fetchConversionOpportunities,
  resetConversionOpportunities,
} from '../../PipelineActions';
import { getCanSetupOrganization } from '../../../Auth/AuthReducer';
import ProgressBar from '../../../../components/progress-bar';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import OpportunityModal from '../../../Analysic/components/opportunity-modal';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';

const USER_PREFERENCE_PIPELINE_SINCE = 'pipeline-since';


class PipelinePage extends Component {
  constructor() {
    super();
    this.state = {
      selectedPipelineSince: null,
      selectedPipelineSinceDisplay: null,
      selectedOpportunityIds: [],
      selectedOpportunitiesGraphType: null,
      query: null,
      isHistory: false,
      selectedTab: 'size',
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onReset = this.onReset.bind(this);
    this.handleUpdatePipelineSince = this.handleUpdatePipelineSince.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onTabSelect = this.onTabSelect.bind(this);
    this.hanldeSearchContextChange = this.hanldeSearchContextChange.bind(this);
  }

  componentWillMount() {
    this.mounted = false;
    const { getUserPreference } = this.context;
    const selectedPipelineSince = getUserPreference(USER_PREFERENCE_PIPELINE_SINCE, 'last-month', true);
    this.setState({
      selectedPipelineSince,
      selectedPipelineSinceDisplay: convertPipeline(selectedPipelineSince),
    });
  }


  componentDidMount() {
    clearCache(this.props.dispatch);
    this.props.dispatch(resetStats()).then(() => {
      this.mounted = true;
    });
  }
  onSelect(selectedOpportunityIds, selectedOpportunitiesGraphType) {
    this.setState({ selectedOpportunityIds, selectedOpportunitiesGraphType });
  }

  onTabSelect(selectedTab) {
    this.setState({ isHistory: selectedTab === 'conversion', selectedTab });
  }

  onSearchChange(criteria) {
    const { selectedPipelineSince } = this.state;
    const { query } = criteria;
    if (this.mounted) {
      this.setState({ query });
      this.props.dispatch(resetConversionOpportunities());
      this.props.dispatch(fetchStats({ ...criteria, pipeline: selectedPipelineSince }))
        .then((results) => {
          const { opportunities, total } = results;
          const returnResults = opportunities.length;
          if (total && returnResults < total) {
            const el = (
              <div>
                Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
              </div>
            );
            this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
          }
          this.props.dispatch(fetchConversionOpportunities({ query, team: criteria.team }));
        });
    }
  }

  onReset() {
    this.props.dispatch(resetStats());
  }

  handleUpdatePipelineSince(option) {
    const { value } = option;
    if (value) {
      this.setState({
        selectedPipelineSince: value,
        selectedPipelineSinceDisplay: convertPipeline(value),
      });
      this.context.updateUserPreference(USER_PREFERENCE_PIPELINE_SINCE, value, true);
    }
  }

  hanldeSearchContextChange(params) {
    const state = {};
    if (params.selectedPipelineSince) {
      state.selectedPipelineSince = params.selectedPipelineSince;
      state.selectedPipelineSinceDisplay = convertPipeline(state.selectedPipelineSince);
    }
    this.setState(state);
  }


  renderError() {
    const { errors, canSetupOrganization } = this.props;
    if (!errors) {
      return null;
    }

    if (errors.code === 100) {
      return (
        <div className="alert alert-danger">
          Missing Conversion Rates Setup.
          {canSetupOrganization &&
            <span>
              &nbsp;
              <Link className="text-active" to="/setup/conversion-rates">Click here to setup Conversion Rates</Link>
            </span>
          }
          {!canSetupOrganization &&
            <div>
              Contact a TruSales&trade; manager for your organization to have them complete the setup process.
            </div>
          }
        </div>
      );
    }
    return (
      <div className="alert alert-danger">
        {(errors.message || 'Server Errors')}
      </div>
    );
  }

  render() {
    const {
      loading, loaded, historyLoading, historyLoaded,
    } = this.props;
    const { isHistory, selectedPipelineSince } = this.state;
    return (
      <div>
        <Helmet title="Pipeline" />
        <RequestFeedbackManager />
        <div className="container">
          <div className="clearfix">
            <div className="pull-right page-header-control">
              <SearchForm
                onSearchChange={this.onSearchChange}
                onReset={this.onReset}
                loadRecommendedCriteria={false}
                pullRight
                type="pipeline"
                overrideFields={{
                  closeDate: {
                    attributes: {
                      includeFuturePredefinedRanges: true,
                    },
                  },
                }}
                disabledFilters={['stage']}
                disabledRootLogic
                defaultCriteria={{
                  type: 'groupAND',
                  values: [],
                }}
                searchContext={{
                  selectedPipelineSince,
                }}
                onSearchContextChange={this.hanldeSearchContextChange}
              >
                <PipelineDateDropdown
                  pipelineSince={this.state.selectedPipelineSince}
                  onUpdate={this.handleUpdatePipelineSince}
                />
              </SearchForm>
            </div>
            <h1 className="page-header">
              Pipeline
            </h1>
            {loading && <ProgressBar />}
            {!loading && loaded &&
              <div>
                <PipelineStats
                  pipelineDate={this.state.selectedPipelineSinceDisplay}
                />
              </div>
            }
            {!loading && !loaded && this.renderError()}
          </div>
        </div>
        {!loading && loaded &&
          <div>
            <PipelineGraphs
              onSelect={this.onSelect}
              query={this.state.query}
              pipelineDate={this.state.selectedPipelineSinceDisplay}
              onTabSelect={this.onTabSelect}
              selectedTab={this.state.selectedTab}
            />
            <div className="container">
              <OpportunityModal
                opportunityIds={this.state.selectedOpportunityIds}
                onClose={() => {
                  this.setState({ selectedOpportunityIds: [], selectedOpportunitiesGraphType: null });
                }}
                getOpportunities={this.state.selectedOpportunitiesGraphType === 'ConversionGraph' ? getConversionGraphOpportunities : getOpportunities}
                tableConfigs={{
                  tableName: 'pipeline-table',
                  hideStageControl: true,
                }}
              />
              {isHistory &&
                <div>
                  {(!historyLoading && historyLoaded) &&
                    <OpportunityTable
                      opportunities={this.props.historyOpportunities}
                      tableName="pipeline-table"
                      title="Opportunity Details"
                    />
                  }
                </div>
              }
              {!isHistory &&
                <div>
                  {(loading || !loaded) && <ProgressBar />}
                  {(!loading && loaded) &&
                    <OpportunityTable
                      opportunities={this.props.opportunities}
                      tableName="pipeline-table"
                      title="Opportunity Details"
                    />
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    canSetupOrganization: getCanSetupOrganization(state),
    loading: getStatsLoading(state),
    loaded: getStatsLoaded(state),
    opportunities: getOpportunities(state),
    historyLoading: getConversionGraphLoading(state),
    historyLoaded: getConversionGraphLoaded(state),
    historyOpportunities: getConversionGraphOpportunities(state),
    errors: getStatsErrors(state),
  };
}

PipelinePage.propTypes = {
  canSetupOrganization: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  errors: PropTypes.shape({}),
  historyLoaded: PropTypes.bool,
  historyLoading: PropTypes.bool,
  historyOpportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

PipelinePage.defaultProps = {
  loaded: false,
  loading: false,
  historyLoaded: false,
  historyLoading: false,
  errors: null,
  canSetupOrganization: false,
};
PipelinePage.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(PipelinePage, ['stage', 'dealType']))));
